export const personaVerificationFee = 3.99;
